<template>
    <div class="verified-input vta">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div :class="icon ? 'field has-addons' : ''">
            <div :class="icon ? 'control is-expanded' : ''">
                <textarea
                    ref="typed"
                    class="v-input"
                    :id="id"
                    v-model="innerValue"
                    :placeholder="
                        disableMLplaceholder
                            ? placeholder
                            : getT(placeholder, '')
                    "
                    :maxlength="maxlength"
                    :class="{
                        invalid: focusedOut && invalid,
                        'disable-transform': disableTransform,
                        'input-icon': icon,
                    }"
                    :disabled="disabled"
                    :readonly="readonly"
                    @focus="focusEvt()"
                    @keyup="onKeyUp()"
                    @input="updateValue()"
                    @blur="blurEvt()"
                    :rows="rows"
                />
            </div>
            <div class="control" v-if="icon">
                <a
                    class="button"
                    @click="inputAction"
                    :class="{
                        'invalid-button-after': focusedOut && invalid,
                        'is-not-clickable': porcentagem,
                        'icon-svg': iconSvg,
                    }"
                >
                    <!-- Caso seja uma imagem baixada -->
                    <svg class="svg-icons" v-if="iconSvg">
                        <use :xlink:href="require(`@/assets/img/icons/${icon}.svg`) + '#layer'" />
                    </svg>
                    <!-- Caso seja do buefy -->
                    <b-icon :icon="icon" v-else />
                </a>
            </div>
        </div>

        <div class="footer-textarea">
            <span
                class="validation"
                v-text="getT(msg, '')"
                v-if="focusedOut && invalid"
            />
            <div class="clearfix" v-else-if="!disabled" />
            <div ref="counterMax" v-if="displayCounter" class="counter">
                {{ value ? value.length : '0' }} /{{ maxlength }}
            </div>
        </div>
    </div>
</template>

<script>
import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        id: {
            default: new Date().getTime(),
        },
        placeholder: {
            default: '',
            type: String,
        },
        maxlength: {
            default: 255,
            type: Number,
        },
        title: {
            default: null,
            type: String,
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        readonly: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        onKeyUp: {
            default: () => {},
            type: Function,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        disableTransform: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: Number,
            default: 3,
        },
        maxRows: {
            type: Number,
            default: () => 0,
        },
        /**
         * Exibe contador de caracteres com o limite
         * @values true or false
         */
        displayCounter: {
            type: Boolean,
            default: () => false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        validchars: {
            type: String,
            default: '',
        },
        porcentagem: {
            type: Boolean,
            default: false,
        },
        icon: {
            default: '',
            type: String,
        },
        // true caso seja um ícone baixado
        iconSvg: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerValue: this.value,
            focusedOut: false,
            caracterLength: 0,
        };
    },
    mounted() {
        this.focusedOut = !this.onBlur;
        this.setMaxRows(this.maxRows);
    },
    watch: {
        value(val) {
            // Pega os dados do value 'pai' somente ao haver alteração
            if (this.valuesAreEqual()) this.innerValue = val;
        },
        innerValue(val) {
            if (this.displayCounter) {
                //atribui cor laraja para quando maxlength estive 60% ate 85% e vermelho quando estiver acima de 85%
                let valueSizePorcentage = (val.length / this.maxlength) * 100;
                if (valueSizePorcentage < 60) {
                    this.$refs.counterMax.style.color = '#4a4a4a';
                } else if (valueSizePorcentage > 60 && valueSizePorcentage < 85) {
                    this.$refs.counterMax.style.color = ' #FF9800';
                } else if (valueSizePorcentage > 85) {
                    this.$refs.counterMax.style.color = ' #F44336';
                }
            }
            // Update do valor somente ao haver alteração
            if (this.valuesAreEqual()) this.updateValue();
        },
    },
    computed: {
        charsregex() {
            if (!this.isNull(this.validchars)) {
                let rgx = '^[#]*$';
                let unc = '';
                let vc_array = this.validchars.split('');

                vc_array.forEach((c) => {
                    unc = unc.concat(`\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`);
                });

                return new RegExp(rgx.replace('#', unc));
            } else {
                return null;
            }
        },
    },
    methods: {
        valuesAreEqual() {
            // Modificado para pegar os dados do value 'pai' somente ao haver alteração
            let tempValue =
                this.onlyNumbers(this.value) || this.isNull(this.value)
                    ? this.value
                    : this.value.toString().toUpperCase();
            let tempInnerValue =
                this.onlyNumbers(this.innerValue) || this.isNull(this.innerValue)
                    ? this.innerValue
                    : this.innerValue.toString().toUpperCase();
            // caso os valores sejam diferentes é chamado a atualização
            return tempInnerValue != tempValue;
        },
        updateValue() {
            let input = this.innerValue;

            if (!this.isNull(this.validchars)) {
                if (
                    this.charsregex &&
                    this.charsregex.test(input ? input.toString().toLowerCase() : '')
                ) {
                    this.$emit('input', input);
                } else {
                    this.innerValue = this.value;
                }
            } else {
                this.$emit('input', input);
            }
        },
        inputAction() {
            this.$emit('input-action');
        },
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
        setMaxRows(maxRows) {
            if (maxRows != 0) {
                this.$refs.typed.addEventListener('keydown', (e) => {
                    if (!this.isNull(this.innerValue)) {
                        var sizeRows = this.innerValue.split('\n').length;
                        if (e.keyCode == 13 && sizeRows >= maxRows) {
                            e.preventDefault();
                            return false;
                        }
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.vta {
    display: flex;
    flex-direction: column;

    .v-input {
        flex-grow: 1;
    }
}

span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.invalid {
    border: 1px solid $red-alert !important;
}

input {
    margin-bottom: 0 !important;
    color: #666666;
    height: 36px;
}

.disable-transform {
    text-transform: none !important;
}

.clearfix {
    height: 12px;
}

div.footer-textarea {
    .validation {
        float: left;
    }
    .clearfix {
        float: left;
    }
    .counter {
        text-align: end;
    }
}
.input-icon {
    border-top-right-radius: 0 !important;
}
.field.has-addons {
    margin-bottom: 0;
    .button {
        height: 36px;
        color: #666666;
        border-color: $table-border;

        &.invalid-button-before {
            border-bottom-color: red;
            border-left-color: red;
            border-top-color: red;
        }
        &.invalid-button-after {
            border-bottom-color: red;
            border-right-color: red;
            border-top-color: red;
        }
    }
    .icon-svg {
        padding-left: 8px;
        padding-right: 8px;
    }
}
</style>
